import { detectBrokenIosInAppBrowser } from "@/lib/inAppEscape/detect";
import { buildExtbrowserUrl } from "@/lib/inAppEscape/escapeAttempts";
import { parseFlaggedLinkUrl } from "./openAppFlag";

/**
 * Workaround for Instagram and Threads on iOS. They open every link in their
 * own WebView, so Universal Links never open the installed app. Sending the
 * link to their external browser does: iOS opens the app if it is installed,
 * and Safari if not. Safari then runs the normal flow. Tested on a device:
 * Instagram on 2026-10-05, Threads on 2026-10-09.
 *
 * Facebook is left out. It can only leave through x-safari, which opens Safari
 * directly and skips Universal Links, so it leaves through a page on another
 * host instead, with no flag (lib/inAppEscape/appBounce.ts).
 *
 * Messenger needs none of this on iOS: it hands links to the system, so the
 * Universal Link opens an installed app without the open-app flag (tested on
 * a device on 2026-10-13). On Android Messenger does need the flag, see
 * appIntent.ts. User docs should say this per platform.
 */
export function buildExternalBrowserUrl(
  pageUrl: string,
  userAgent: string
): string | null {
  const browser = detectBrokenIosInAppBrowser(userAgent);
  if (browser !== "instagram" && browser !== "threads") return null;

  const linkUrl = parseFlaggedLinkUrl(pageUrl);
  if (!linkUrl) return null;

  return buildExtbrowserUrl(browser, linkUrl.href);
}
